import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "text", "icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef } from 'react';
import mergeCallbacks from 'utils/ui/mergeCallbacks';
import * as MenuListUI from 'components/MenuList';
import { useNavMenuContext } from './NavMenu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NavMenuItem(_ref) {
  var as = _ref.as,
    children = _ref.children,
    text = _ref.text,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var itemRef = useRef(null);
  var _useNavMenuContext = useNavMenuContext(),
    itemList = _useNavMenuContext.itemList;
  var clearHighlightedItem = itemList.clearHighlightedItem;
  var childrenAsText = typeof children === 'string' ? children : '';
  var _itemList$useItem = itemList.useItem({
      ref: itemRef,
      text: text || childrenAsText,
      value: text || childrenAsText
    }),
    select = _itemList$useItem.select,
    highlight = _itemList$useItem.highlight,
    useHighlighted = _itemList$useItem.useHighlighted;
  if (typeof children !== 'string' && !text) {
    // eslint-disable-next-line no-console
    console.warn('NavMenuItem: The type of the children prop is not "string". Please provide a string-only label to the menu item via the "text" prop.', children);
  }
  var forwardedAs = as || 'button';
  return /*#__PURE__*/_jsx(MenuListUI.Item, {
    children: /*#__PURE__*/_jsxs(MenuListUI.Link, _objectSpread(_objectSpread({}, otherProps), {}, {
      ref: itemRef,
      forwardedAs: forwardedAs,
      isHighlighted: useHighlighted(),
      onClick: mergeCallbacks(select, otherProps.onClick),
      onFocus: mergeCallbacks(highlight, otherProps.onFocus),
      onMouseEnter: mergeCallbacks(highlight, otherProps.onMouseEnter),
      onMouseLeave: mergeCallbacks(clearHighlightedItem, otherProps.onMouseLeave),
      children: [icon && /*#__PURE__*/_jsx(MenuListUI.ItemIcon, {
        name: icon
      }), children]
    }))
  });
}
export default NavMenuItem;